// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ComponentsFragmentDoc } from '../component.generated';
export const ComponentGlobalComponentFragmentDoc = gql`
    fragment componentGlobalComponent on ComponentGlobalComponent {
  backgroundColor
  components {
    ...components
  }
}
    ${ComponentsFragmentDoc}`;